<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
@if (isScreenSmall) {
  <fuse-vertical-navigation class="dark bg-gray-900 print:hidden" [mode]="'over'" [name]="'mainNavigation'"
    [navigation]="navigation.default" [opened]="false">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
      <!-- Logo -->
      <div class="flex h-20 items-center px-8 pt-6">
        <img class="w-48" src="images/logo/logo-text-on-dark.svg" alt="Logo image" />
      </div>
    </ng-container>
  </fuse-vertical-navigation>
}

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col items-center bg-gray-200 dark:bg-card">
  <!-- Header -->
  <div
    class="relative z-49 flex h-16 w-full flex-0 flex-col justify-center overflow-hidden shadow dark:shadow-none sm:h-20 md:h-36 print:hidden">
    <!-- Top bar -->
    <div class="dark relative flex w-full flex-auto justify-center bg-gray-800 px-4 dark:bg-gray-900 md:px-8">
      <div class="flex h-16 w-full max-w-360 items-center sm:h-20">
        <!-- Logo -->
        @if (!isScreenSmall) {
          <div class="flex items-center">
            <img class="w-48" src="images/logo/logo-text-on-dark.svg" alt="Logo image" />
          </div>
        }
        <!-- Navigation toggle button -->
        @if (isScreenSmall) {
          <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
          </button>
        }
        <!-- Components -->
        <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
          @if (envConfigService.envConfig.enableMultiLanguage) {
            <languages></languages>
          }
          @if (envConfigService.envConfig.enableFullScreen) {
            <fuse-fullscreen class="hidden md:block"
            ></fuse-fullscreen>
          }
          @if (envConfigService.envConfig.enableGlobalSearch) {
            <search [appearance]="'bar'"></search>
          }
          @if (envConfigService.envConfig.enableShortcuts) {
            <shortcuts></shortcuts>
          }
          @if (envConfigService.envConfig.enableInboxMessages) {
            <messages></messages>
          }
          @if (envConfigService.envConfig.enableNotifications) {
            <notifications></notifications>
          }
          @if (envConfigService.envConfig.enableChats) {
            <button class="lg:hidden" mat-icon-button (click)="quickChat.toggle()"
              >
                        <mat-icon [svgIcon]="
                                'heroicons_outline:chat-bubble-left-right'
                            "></mat-icon>
            </button>
          }
          <user></user>
        </div>
      </div>
    </div>
    <!-- Bottom bar -->
    @if (!isScreenSmall) {
      <div class="bg-card flex flex-auto justify-center px-4 dark:bg-gray-700 md:px-8">
        <div class="relative flex h-16 w-full max-w-360 items-center">
          <fuse-horizontal-navigation class="-mx-4" [name]="'mainNavigation'"
          [navigation]="navigation.horizontal"></fuse-horizontal-navigation>
        </div>
      </div>
    }
  </div>

  <!-- Content -->
  <div class="flex w-full flex-auto justify-center sm:p-6 md:p-8">
    <div
      class="bg-default flex w-full flex-auto flex-col sm:max-w-360 sm:overflow-hidden sm:rounded-lg sm:shadow-lg">
      <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
      Otherwise, layout changes won't be registered and the view won't be updated! -->
      @if (true) {
        <div class="flex flex-row p-3 px-5 sm:py-2  bg-card dark:bg-transparent border-b">
          <!-- Custome title -->
          <h2 class="text-2xl md:text-2xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate">
            {{customerHeaderService.title()}}
          </h2>
          @if (customerHeaderService.showRouterLink()) {
            <button mat-mini-fab color="primary" class="mx-5"
              [routerLink]="customerHeaderService.newEntityRouterLink()"><mat-icon>add</mat-icon> </button>
            }
          </div>
          <router-outlet></router-outlet>
        }
      </div>
    </div>

    <!-- Footer -->
    <app-footer></app-footer>
  </div>

  <!-- Quick chat -->
  @if (envConfigService.envConfig.enableChats) {
    <quick-chat #quickChat="quickChat"></quick-chat>
  }